<template>
  <svg aria-hidden="true" focusable="false" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g id="copy">
      <path
        d="m20 2h-12c-1.103 0-2 .897-2 2v2h-2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-2h2c1.103 0 2-.897 2-2v-12c0-1.103-.897-2-2-2zm-4 18h-12v-12h2v8c0 1.103.897 2 2 2h8zm3.997-4h-11.997v-12h12z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4CopySvg"
};
</script>
